import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { PerformanceService } from '../../services/performance-service';

export const PerformanceMark = React.forwardRef(({ children, comparator, name, pollTimer }, ref) => {
  const [mark, setMark] = useState();
  const intervalId = useRef();

  useEffect(() => {
    if (!mark) {
      if (!comparator || comparator()) {
        setMark(PerformanceService.mark(name));
      } else if (comparator && pollTimer) {
        intervalId.current = global.window.setInterval(() => {
          if (comparator()) {
            global.window.clearInterval(intervalId.current);
            setMark(PerformanceService.mark(name));
          }
        }, pollTimer);
      }
    }

    if (ref) {
      // oxlint-disable-next-line no-param-reassign
      ref.current = mark;
    }

    return () => {
      if (intervalId.current) {
        global.window.clearInterval(intervalId.current);
      }
    };
  }, [comparator, intervalId, mark, name, pollTimer, ref, setMark]);

  if (!children) {
    return null;
  }

  if (typeof children === 'function') {
    return children(mark);
  }

  return <React.Fragment>{children}</React.Fragment>;
});

PerformanceMark.displayName = 'PerformanceMark';
PerformanceMark.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  comparator: PropTypes.func,
  name: PropTypes.string.isRequired,
  pollTimer: PropTypes.number,
};
